import { styled } from "styled-components";
import { ChevronDownIcon, Text } from "@pancakeswap/uikit";

export interface DetailsProps {
  actionPanelToggled: boolean;
}

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding-right: 0px;
  }
`;

const ArrowIcon = styled(ChevronDownIcon)<{ $toggled?: boolean }>`
  transform: ${({ $toggled }) => ($toggled ? "rotate(180deg)" : "rotate(0)")};
  height: 20px;
`;

const Details: React.FC<React.PropsWithChildren<DetailsProps>> = ({ actionPanelToggled }) => {
  return (
    <Container>
      <Text color="textSubtle" fontSize={14}>Details</Text>
      <ArrowIcon color="textSubtle" $toggled={actionPanelToggled} />
    </Container>
  );
};

export default Details;
